module.exports = __webpack_public_path__ + "media/images/_eyecatch-submittion-18c8c0f5f210df75e0a31b30935883e6.svg";